import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fa8e32a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom fixed z-50 w-screen h-screen bg-brand-custom flex flex-col items-center justify-center gap-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "logo.svg",
    alt: "logo tecnospeed",
    class: "white-logo w-56 mt-3 pr-6 border-solid border-r-2 border-white"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-white font-bold text-8xl leading-none pl-6" }, "404")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-white font-bold text-2xl px-6 text-center" }, "Ops... a página que você procurou não existe!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_PrimaryButton, {
      id: "button",
      class: "w-32 bg-white hover:bg-gray-200 focus:bg-gray-200",
      label: "Voltar",
      labelClass: "text-black",
      icon: _ctx.buttonIcon,
      onClick: _ctx.handleBack
    }, null, 8, ["icon", "onClick"])
  ]))
}